import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'ramda/src/isEmpty';
import Icon from '@components/@core/Icon';
import HDropdown from '@components/HoverDropdown';

function Careers(props) {
    const { data, onMenu } = props;
    return (
        <div className="careers-report-list">
            <div className="d-flex border-bottom py-3 desktop-screen" data-cy="careersHeading">
                <div className="d-flex-7 dsl-m12 text-400" data-cy="careers">
                    Careers
                </div>
                <div data-cy="open" className="d-flex-1 text-sm-right dsl-m12 text-400">
                    Open
                </div>
                <div data-cy="openEmployee" className="d-flex-8 dsl-m12 ms-sm-3 px-3 text-400">
                    Employees
                </div>
                <div data-cy="completed" className="d-flex-2 text-sm-right dsl-m12 text-400">
                    Completed
                </div>
                <div data-cy="completedEmployees" className="d-flex-8 dsl-m12 px-3 text-400">
                    Employees
                </div>
                <div className="d-flex-1" />
            </div>
            {isEmpty(data) ? (
                <div className="d-h-center pt-4">
                    <span className="dsl-m16">No Careers Assigned</span>
                </div>
            ) : (
                data.map((program, index) => {
                    const openEmployees = program.stats?.open_employees
                        ? program.stats?.open_employees.map((e) => {
                              const { id, profile, program } = e;
                              return {
                                  id,
                                  program,
                                  value: `${profile.first_name} ${profile.last_name}`,
                              };
                          })
                        : [];
                    const completedEmployees = program.stats?.completed_employees
                        ? program.stats?.completed_employees.map((e) => {
                              const { id, profile } = e;
                              return {
                                  id,
                                  program,
                                  value: `${profile.first_name} ${profile.last_name}`,
                              };
                          })
                        : [];
                    return (
                        <div className="d-flex ssm-column ai-center border-bottom py-0 py-md-4 career" key={`pr${index}`} data-cy="careerRows">
                            <div className="d-flex ai-center d-flex-7 cursor-pointer w-100 careersTitle">
                                <Icon name="fas fa-user-tie" size={22} />
                                <span className="dsl-b14 ms-3 text-400" data-cy="careersTitle">
                                    {program.title}
                                </span>
                            </div>
                            <div data-cy="careerOpen" className="d-flex-1 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Open</label>
                                {program.stats?.open}
                            </div>
                            <div data-cy="assignEmployee" className="d-flex-8 d-flex dsl-b14 px-0 px-sm-3 text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Employee</label>
                                <HDropdown placeholder="No employee" data={openEmployees} onClick={(e) => onMenu('view', e)} />
                            </div>
                            <div data-cy="completed" className="d-flex-2 dsl-b14 text-end ssm-left text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Completed</label>
                                {program.stats?.completed}
                            </div>
                            <div data-cy="completedEmployee" className="d-flex-8 d-flex dsl-b14 px-0 px-sm-3 text-400 w-100">
                                <label className="dsl-b14 mobile-screen w-30">Employee</label>
                                <HDropdown placeholder="No employee" data={completedEmployees} onClick={(e) => onMenu('view', e)} />
                            </div>
                            <div className="d-flex-1">
                                {/* disable it for now
                <EditDropdown options={ManageReportMenu[role]} onChange={e => onMenu(e, program)} /> */}
                            </div>
                        </div>
                    );
                })
            )}
        </div>
    );
}

Careers.propTypes = {
    data: PropTypes.array,
    onMenu: PropTypes.func,
};

Careers.defaultProps = {
    data: [],
    onMenu: () => {},
};

export default Careers;
